import { useEffect, useRef } from "react";

export default ({ checked, ...props }) => {
    const checkboxRef = useRef();

    useEffect(() => {
        if(checkboxRef.current) {
            checkboxRef.current.indeterminate = checked === null;
        }
    }, [checked]);

    return (
        <input
            type="checkbox"
            ref={checkboxRef}
            checked={checked === true}
            { ...props }
        />
    );
};
